import { composeRssImageCaptionLine } from './composeRssImageCaptionLine';
import { type RssImageCaptionTag, resolveRssImageCaption } from './resolveRssImageCaption';
import { type RssImageCreditTag, resolveRssImageCredit } from './resolveRssImageCredit';

export type RssThumbnailCaptionArticle = {
  thumbnail_caption?: string | null;
  thumbnail_media_title?: string | null;
  thumbnail_figcaption?: string | null;
  thumbnail_credit?: string | null;
  thumbnail_creator?: string | null;
  thumbnail_copyright?: string | null;
};

export type RssThumbnailCaptionSettings = {
  displayThumbnail?: boolean;
  displayImageCaption?: boolean;
  displayImageCredit?: boolean;
  imageCaptionTag?: RssImageCaptionTag | null;
  imageCreditTag?: RssImageCreditTag | null;
  imageCreditPrefix?: string | null;
};

export const buildRssThumbnailCaptionHtml = (
  article: RssThumbnailCaptionArticle,
  settings: RssThumbnailCaptionSettings | undefined,
): string | null => {
  return composeRssImageCaptionLine({
    displayThumbnail: settings?.displayThumbnail,
    displayImageCaption: settings?.displayImageCaption,
    displayImageCredit: settings?.displayImageCredit,
    thumbnailCaption: resolveRssImageCaption({
      imageCaptionTag: settings?.imageCaptionTag,
      imageCreditTag: settings?.imageCreditTag,
      thumbnailCaption: article.thumbnail_caption,
      thumbnailMediaTitle: article.thumbnail_media_title,
      thumbnailFigcaption: article.thumbnail_figcaption,
    }),
    thumbnailCredit: resolveRssImageCredit({
      imageCreditTag: settings?.imageCreditTag,
      thumbnailCredit: article.thumbnail_credit,
      thumbnailCaption: article.thumbnail_caption,
      thumbnailCreator: article.thumbnail_creator,
      thumbnailCopyright: article.thumbnail_copyright,
    }),
    creditPrefix: settings?.imageCreditPrefix,
  });
};
